<template>
  <div>
    <TopBar />

    <ActiveWorkSession />

    <v-card v-if="getUser.workSession != null" class="mt-2">
      <v-toolbar
        color="deep-purple accent-4"
        dark
      >
        <v-toolbar-title>Workers list</v-toolbar-title>

        <div class="flex-grow-1"></div>

        <router-link :to="{name: 'worksession.workers'}">
          <v-btn icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <v-list>
        <v-list-item v-if="getUser.workSession.workLogs.length === 0">
          No employees in this worksession
        </v-list-item>
        <v-list-item
          v-for="workLog in getUser.workSession.workLogs"
          :key="workLog.workLogId"
        >
          <v-list-item-avatar>
            <v-img :src="workLog.worker.photo || `${publicPath}img/no-photo.png`"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="workLog.worker.name"></v-list-item-title>
            <v-list-item-subtitle v-text="workLog.worker.workerType + ' at ' + workLog.worker.employeeType"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-list-item-action-text v-text="workLog.hoursWorked + ' hrs.'"></v-list-item-action-text>
            <v-icon @click="editableWorkLogId = editableWorkLogId !== workLog.workLogId ? workLog.workLogId : null" v-show="editableWorkLogId !== workLog.workLogId">
              mdi-clock
            </v-icon>
            <div v-show="editableWorkLogId === workLog.workLogId">
              <v-btn icon  @click="decWorkLogTime(workLog)" :loading="pendingWorklogEdit"><v-icon>mdi-minus</v-icon></v-btn>
              <v-btn icon  @click="incWorkLogTime(workLog)" :loading="pendingWorklogEdit"><v-icon>mdi-plus</v-icon></v-btn>
              <v-btn icon @click="editableWorkLogId = null"><v-icon red>mdi-close</v-icon></v-btn>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import TopBar from '../components/TopBar'
import ActiveWorkSession from '../components/ActiveWorkSession'

export default {
  components: {
    TopBar,
    ActiveWorkSession
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      editableWorkLogId: null,
      pendingWorklogEdit: false,
    }
  },
  methods: {
    // ...mapActions(['deleteWorksession']),
    // doDeleteWorksession () {
    //   this.deleteWorksession(this.getUser.workSession.workSessionId)
    // }
    ...mapActions(['updateWorkLogHours']),
    decWorkLogTime(workLog) {
      this.pendingWorklogEdit = true
      let newTime = workLog.hoursWorked - 0.5 >= 0 ? workLog.hoursWorked - 0.5 : 0
      this.updateWorkLogHours({workLogId: workLog.workLogId, spentHours: newTime}).then(resp => this.pendingWorklogEdit = false)
    },
    incWorkLogTime(workLog) {
      this.pendingWorklogEdit = true
      let newTime = workLog.hoursWorked + 0.5 <= 23 ? workLog.hoursWorked + 0.5 : workLog.hoursWorked
      this.updateWorkLogHours({workLogId: workLog.workLogId, spentHours: newTime}).then(resp => this.pendingWorklogEdit = false)
    }
  },
  computed: {
    ...mapGetters(['getUser', 'activeWS'])
  }
}
</script>
